import { IPagination } from 'app/types/common';

export interface IOrganisationsState {
  readonly organisationsById?: any;
  readonly organisationIds?: string[];
  readonly hasSaved?: boolean;
  readonly hasLoaded?: boolean;
  readonly hasFailed?: boolean;
  readonly isLoading?: boolean;
  readonly isSaving?: boolean;
  readonly backendErrors?: any;
  readonly organisationOrganisationIds?: string[];
  readonly currentOrganisationId?: string;
  readonly filterConfig?: any;
  readonly sortConfig?: any;
  readonly pagination?: IPagination;
}

export interface IOrganisationsSelector extends IOrganisationsState {
  readonly currentOrganisation?: any;
  readonly getOrganisationsFilteredByTagInSelectFormat?: any;
  readonly organisationsByIdInSelectFormat?: any;
}

export enum OrganisationsActionTypes {
  GET_ALL_ORGANISATIONS_REQUESTED = 'redux-app/organisations/GET_ALL_ORGANISATIONS_REQUESTED',
  GET_ALL_ORGANISATIONS_PENDING = 'redux-app/organisations/GET_ALL_ORGANISATIONS_PENDING',
  GET_ALL_ORGANISATIONS_SUCCESS = 'redux-app/organisations/GET_ALL_ORGANISATIONS_SUCCESS',
  GET_ALL_ORGANISATIONS_FAIL = 'redux-app/organisations/GET_ALL_ORGANISATIONS_FAIL',
  GET_ORGANISATION_REQUESTED = 'redux-app/organisations/GET_ORGANISATION_REQUESTED',
  GET_ORGANISATION_PENDING = 'redux-app/organisations/GET_ORGANISATION_PENDING',
  GET_ORGANISATION_SUCCESS = 'redux-app/organisations/GET_ORGANISATION_SUCCESS',
  GET_ORGANISATION_FAIL = 'redux-app/organisations/GET_ORGANISATION_FAIL',
  UPDATE_ORGANISATION_REQUESTED = 'redux-app/organisations/UPDATE_ORGANISATION_REQUESTED',
  UPDATE_ORGANISATION_PENDING = 'redux-app/organisations/UPDATE_ORGANISATION_PENDING',
  UPDATE_ORGANISATION_SUCCESS = 'redux-app/organisations/UPDATE_ORGANISATION_SUCCESS',
  UPDATE_ORGANISATION_FAIL = 'redux-app/organisations/UPDATE_ORGANISATION_FAIL',
  CREATE_ORGANISATION_REQUESTED = 'redux-app/organisations/CREATE_ORGANISATION_REQUESTED',
  CREATE_ORGANISATION_PENDING = 'redux-app/organisations/CREATE_ORGANISATION_PENDING',
  CREATE_ORGANISATION_SUCCESS = 'redux-app/organisations/CREATE_ORGANISATION_SUCCESS',
  CREATE_ORGANISATION_FAIL = 'redux-app/organisations/CREATE_ORGANISATION_FAIL',
  DELETE_ORGANISATION_REQUESTED = 'redux-app/organisations/DELETE_ORGANISATION_REQUESTED',
  DELETE_ORGANISATION_PENDING = 'redux-app/organisations/DELETE_ORGANISATION_PENDING',
  DELETE_ORGANISATION_SUCCESS = 'redux-app/organisations/DELETE_ORGANISATION_SUCCESS',
  DELETE_ORGANISATION_FAIL = 'redux-app/organisations/DELETE_ORGANISATION_FAIL',
  SELECT_ORGANISATION_REQUESTED = 'redux-app/organisations/SELECT_ORGANISATION_REQUESTED',
}

export default null;
